import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';

export class PolishOwlDateTimeIntl extends OwlDateTimeIntl {
  override upSecondLabel = 'Dodaj sekundę';
  override downSecondLabel = 'Odejmij sekundę';
  override upMinuteLabel = 'Dodaj minutę';
  override downMinuteLabel = 'Odejmij minutę';
  override upHourLabel = 'Dodaj godzinę';
  override downHourLabel = 'Odejmij godzinę';
  override prevMonthLabel = 'Poprzedni miesiąc';
  override nextMonthLabel = 'Następny miesiąc';
  override prevYearLabel = 'Poprzedni rok';
  override nextYearLabel = 'Następny rok';
  override prevMultiYearLabel = 'Poprzednie 21 lat';
  override nextMultiYearLabel = 'Następne 21 lat';
  override switchToMonthViewLabel = 'Przełącz na widok miesięczny';
  override switchToMultiYearViewLabel = 'Wybierz miesiąc i rok';
  override cancelBtnLabel = 'Anuluj';
  override setBtnLabel = 'Ustaw';
  override rangeFromLabel = 'Od';
  override rangeToLabel = 'Do';
  override hour12AMLabel = 'Rano';
  override hour12PMLabel = 'Po południu';
}
